import React, { CSSProperties } from 'react';
import Draggable from 'react-draggable';
import Paper, { PaperProps } from '@mui/material/Paper';
import { Dialog, DialogTitle, IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitleProps, DialogWrapperProps } from './types';

export const PaperComponent = (props: PaperProps) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
};

export const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, style, ...other } = props;
  const defaultStyle: CSSProperties = { minHeight: 44, cursor: 'move' };
  return (
    <DialogTitle sx={{ m: 0, paddingY: 1 }} {...other} style={{ ...defaultStyle, ...style }}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export const DialogWrapper = styled((props: DialogWrapperProps) => {
  const { muiPaperRoot, ...dialogProps } = props;
  return (
    <Dialog {...dialogProps} />
  );
})((props: DialogWrapperProps) => {
  const { muiPaperRoot } = props;
  return (
    {
      '& .MuiPaper-root': {
        // minWidth: '600px',
        ...muiPaperRoot,
      },
    }
  );
});
